module.exports = __webpack_public_path__ + "img/KI-Pilot-Praxis-small.5372556f.png";